import { render, staticRenderFns } from "./TooltipedBtn.vue?vue&type=template&id=0a8c82e0"
import script from "./TooltipedBtn.vue?vue&type=script&lang=js"
export * from "./TooltipedBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports